import { call, put, takeLatest } from 'redux-saga/effects';

import { apiURL } from 'config/baseURL';
import { gatewayFetch } from 'helpers/api';
import { getToken } from '../api';
import { APIResponse } from '../../constants/ResponseCollection';
import * as actions from './passwordConfiguration.actions';
import * as types from './passwordConfiguration.actionsTypes';

/**
 * Deliberately uncached, unlike `organizations.actionsSaga.ts`. Its 30-minute window is why an
 * admin could change the policy and still be rejected for half an hour — this value is read at
 * password-set time, so a stale copy is a broken feature, not a slow one.
 */
export function* fetchPasswordConfiguration(action: ReturnType<typeof actions.fetchPasswordConfiguration.request>) {
	const { organizationID } = action.payload;

	try {
		const authToken = yield getToken();
		const options = {
			method: 'GET',
			headers: {
				Authorization: authToken,
			},
		};

		const strURL = `${apiURL}/organizations/${organizationID}/password-configuration`;
		const request = () => gatewayFetch(strURL, options);
		const response = yield call(request);

		if (response && response.status === APIResponse.CODE.SUCCESS) {
			const responseData = yield response.json();
			yield put(
				actions.fetchPasswordConfiguration.success({
					passwordConfiguration: responseData.data.passwordConfiguration,
				}),
			);
		} else {
			const responseData = yield response.json();
			yield put(actions.fetchPasswordConfiguration.failure({ error: responseData.message }));
		}
	} catch (e) {
		yield put(actions.fetchPasswordConfiguration.failure({ error: 'Failed to fetch password configuration' }));
	}
}

export default function* passwordConfigurationSaga() {
	yield takeLatest(types.GET_PASSWORD_CONFIGURATION_REQUEST, fetchPasswordConfiguration);
}
